import { createContext } from 'react';

export interface LocaleType {
    value: string;
    prefix: string;
}

const defaultLocale: LocaleType = {
    value: 'en-us',
    prefix: 'en',
};

const LocaleContext = createContext(defaultLocale);

const LocaleProvider = LocaleContext.Provider;
export { LocaleContext, LocaleProvider };
